import {
  NON_PATIENT_ACTIVITY_UPDATE_REQUEST,
  NON_PATIENT_ACTIVITY_UPDATE_FAILURE,
  NON_PATIENT_ACTIVITY_UPDATE_SUCCESS,
  NON_PATIENT_ACTIVITY_CREATE_REQUEST,
  NON_PATIENT_ACTIVITY_CREATE_SUCCESS,
  NON_PATIENT_ACTIVITY_CREATE_FAILURE,
} from '../../../actions/constants/types';

const initialUpdateState = {
  isAssigning: false,
};

function assignNonPatientActivity(state = initialUpdateState, action) {
  switch (action.type) {
    case NON_PATIENT_ACTIVITY_UPDATE_REQUEST:
    case NON_PATIENT_ACTIVITY_CREATE_REQUEST:
      return {
        isAssigning: true,
      };
    case NON_PATIENT_ACTIVITY_UPDATE_FAILURE:
    case NON_PATIENT_ACTIVITY_UPDATE_SUCCESS:
    case NON_PATIENT_ACTIVITY_CREATE_SUCCESS:
    case NON_PATIENT_ACTIVITY_CREATE_FAILURE:
      return {
        isAssigning: false,
      };
    default:
      return state;
  }
}

export default assignNonPatientActivity;
